module.exports = __webpack_public_path__ + "9779d9a1/img/pwrd-by-sourcery-black.bba9ba41.svg";